export interface BrowserInfo {
  colorDepth: number
  javaEnabled: boolean
  screenHeight: number
  screenWidth: number
  timeZoneOffset: number
}

export default (): BrowserInfo => {
  return {
    colorDepth: window.screen.colorDepth,
    javaEnabled: navigator.javaEnabled(),
    screenHeight: window.screen.height,
    screenWidth: window.screen.width,
    timeZoneOffset: new Date().getTimezoneOffset(),
  }
}
